export const getBalance = state => state.userBalance.balance;
export const isLoadingValue = state => state.userBalance.isLoading;
